<template>
  <div class="renwu">
    <!-- 企业加项信息 -->
    <div>
      <div class="top">
        <Date-picker
          @on-change="datePicker"
          class="data"
          type="daterange"
          :options="options"
          placeholder="选择日期"
        ></Date-picker>
      </div>
      <div class="table-cont">
        <Table
          @on-sort-change="changesort"
          stripe
          :columns="columns"
          :data="data"
        ></Table>
      </div>
      <div class="page-div">
        <Page
          @on-page-size-change="changepeoplepage"
          @on-change="changePeoplecurrent"
          :total="obj.total"
          show-elevator
          show-total
          :current="current"
          :page-size="pageSize"
          show-sizer
          class="page-div-page"
        />
      </div>
    </div>
    <Alert class="alertTitle" v-show="alertTitleIshow" show-icon type="success"
      >操作成功</Alert
    >
    <Alert
      class="alertTitle"
      v-show="alertTitleIshow2"
      type="error"
      show-icon
      >{{ alertTitle }}</Alert
    >

    <!-- <Spin fix v-show="isiconfontshow">
      <span class="iconfont demo-spin-icon-load ivu-icon">&#xe71d;</span>
      <div>距离有些遥远，小简 正在努力中……</div>
    </Spin> -->

    <!--  -->
    <Modal
      class="ivumodal"
      footer-hide
      width="800"
      v-model="seeShow"
      title="加项清单"
    >
      <div class="table-cont">
        <Table
          @on-sort-change="changesort2"
          stripe
          :columns="columns2"
          :data="data2"
        ></Table>
      </div>
      <div class="page-div" style="margin-top:15px;">
        <Page
          @on-page-size-change="changepeoplepage2"
          @on-change="changePeoplecurrent2"
          :total="obj2.total"
          show-elevator
          show-total
          :current="current2"
          :page-size="pageSize2"
          show-sizer
          class="page-div-page"
        />
      </div>
      <div style="clear:both;"></div>
    </Modal>
  </div>
</template>
<script>
    import {
        formatMoney,
        selectOrgFeeItemList,
        selectByPatientId
    } from "../servers/api";
    export default {
        name: "qiyeaddxiang",
        data() {
            return {
                isiconfontshow: false,
                alertTitleIshow: false,
                alertTitleIshow2: false,
                alertTitle: "",
                data: [{
                    name: "一个字我",
                    age: 18,
                    address: "New"
                }, {
                    name: "大啊",
                    age: 24,
                    address: "London "
                }],
                background: "#fff",
                columns: [{
                    type: "selection",
                    width: 60,
                    align: "center",
                    fixed: "left"
                }, {
                    title: "体检者归类",
                    align: "center",
                    key: "medicalType",
                    ellipsis: true,
                    sortable: true,
                    width: 220,
                    render: (h, params) => {
                        let a = "";
                        if (params.row.medicalType == 1) {
                            a = "团检";
                        } else {
                            a = "个检";
                        }
                        return h("div", {}, a);
                    }
                }, {
                    title: "团体名称",
                    align: "center",
                    key: "orgName",
                    ellipsis: true,
                    sortable: true,
                    width: 250,
                    render: (h, params) => {
                        return h(
                            "div", {
                                style: {
                                    color: "#53CAC3",
                                    cursor: "pointer"
                                },
                                on: {
                                    click: () => {
                                        this.$emit("tellFalse", params.row);
                                    }
                                }
                            },
                            params.row.orgName
                        );
                    }
                }, {
                    title: "任务名称",
                    align: "center",
                    ellipsis: true,
                    sortable: true,
                    width: 250,
                    key: "reservationName"
                }, {
                    title: "预约时间",
                    align: "center",
                    width: 200,
                    ellipsis: true,
                    sortable: true,
                    key: "reservationTime",
                    render: (h, params) => {
                        let a = params.row.reservationTime;
                        let num = "";
                        if (a) {
                            num = a.slice(0, 10);
                        }

                        return h(
                            "div", {
                                style: {
                                    height: "30px",
                                    "line-height": "30px",
                                    "text-align": "center",
                                    "font-size": "13px",
                                    color: "#7F7F7F"
                                }
                            },
                            num
                        );
                    }
                }, {
                    title: "姓名",
                    width: 150,
                    align: "center",
                    key: "patientName",
                    ellipsis: true,
                    sortable: true
                }, {
                    title: "性别",
                    align: "center",
                    width: 150,
                    ellipsis: true,
                    sortable: true,
                    key: "sex"
                }, {
                    title: "年龄",
                    width: 150,
                    align: "center",
                    ellipsis: true,
                    sortable: true,
                    key: "age"
                }, {
                    title: "手机号",
                    align: "center",
                    width: 150,
                    ellipsis: true,
                    sortable: true,
                    key: "phone"
                }, {
                    title: "操作",
                    key: "awssd",
                    align: "center",
                    width: 120,
                    fixed: "right",
                    render: (h, params) => {
                        return h(
                            "div", {
                                style: {
                                    height: "30px",
                                    "line-height": "30px",
                                    "text-align": "center",
                                    "font-size": "13px",
                                    background: this.background,
                                    border: "1px solid #53CAC3",
                                    "border-radius": "5px",
                                    width: "65px",
                                    "margin-left": "12px",
                                    cursor: "pointer"
                                },
                                on: {
                                    click: () => {
                                        //    console.log(params.row)
                                        this.chengeTable(params.row);
                                        //    this.background =
                                    }
                                }
                            },
                            "查看"
                        );
                    }
                }],
                data2: [],
                columns2: [{
                    type: "selection",
                    width: 60,
                    align: "center"
                }, {
                    title: "订单号",
                    key: "orderNum",
                    width: 150,
                    ellipsis: true,
                    sortable: true,
                    align: "center"
                }, {
                    title: "项目名称",
                    key: "examFeeItemName",
                    width: 150,
                    ellipsis: true,
                    sortable: true,
                    align: "center",
                    render: (h, params) => {
                        let a = params.row.examFeeItemName;
                        return h("div", [
                            h(
                                "span", {
                                    style: {
                                        display: "inline-block",
                                        width: "100%",
                                        height: "30px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        "line-height": "37px",
                                        color: "#7F7F7F"
                                    }
                                },
                                a
                            )
                        ]);
                    }
                }, {
                    title: "项目金额",
                    key: "unitPrice",
                    ellipsis: true,
                    sortable: true,
                    align: "center",
                    render: (h, params) => {
                        let a = "￥" + formatMoney(params.row.unitPrice);
                        return h("div", [
                            h(
                                "span", {
                                    style: {
                                        display: "inline-block",
                                        width: "100%",
                                        height: "30px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        "line-height": "37px",
                                        color: "#7F7F7F"
                                    }
                                },
                                a
                            )
                        ]);
                    }
                }, {
                    title: "付款方式",
                    key: "paymentMethod",
                    ellipsis: true,
                    sortable: true,
                    align: "center",
                    render: (h, params) => {
                        let a = "";
                        if (params.row.paymentMethod == 1) {
                            a = "微信";
                        } else {
                            a = "支付宝";
                        }
                        return h("div", [
                            h(
                                "span", {
                                    style: {
                                        display: "inline-block",
                                        width: "100%",
                                        height: "30px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        "line-height": "37px",
                                        color: "#7F7F7F"
                                    }
                                },
                                a
                            )
                        ]);
                    }
                }, {
                    title: "付款时间",
                    key: "name",
                    width: 150,
                    ellipsis: true,
                    sortable: true,
                    align: "payTime"
                }],
                current: 1,
                current2: 1,
                options: {
                    shortcuts: [{
                        text: "最近一周",
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            return [start, end];
                        }
                    }, {
                        text: "最近一个月",
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            return [start, end];
                        }
                    }, {
                        text: "最近三个月",
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            return [start, end];
                        }
                    }]
                },
                seeShow: false,
                pageSize: 20,
                pageSize2: 20,
                obj: {},
                obj2: {},
                startDate: "",
                endDate: "",
                orderField: "",
                isAsc: "",
                idOrgReservation: "",
                patientId: ""
            };
        },
        created() {},
        methods: {
            changesort(item) {
                //排序
                this.orderField = item.key;
                this.isAsc = item.order;
                this.current = 1;
                if (item.order == "normal") {
                    this.isAsc = "";
                    this.orderField = "";
                }
                this.selectOrgFeeItemList(1);
            },
            changesort2(item) {
                this.orderField = item.key;
                this.isAsc = item.order;
                this.current = 1;
                if (item.order == "normal") {
                    this.isAsc = "";
                    this.orderField = "";
                }
                this.selectByPatientId(1);
            },
            datePicker(data) {
                //时间搜索
                this.startDate = data[0];
                this.endDate = data[1];
                this.orderField = "";
                this.isAsc = "";
                this.selectOrgFeeItemList(1);
            },
            changepeoplepage(num) {
                //换每页请求多少条
                this.pageSize = num;
                this.selectOrgFeeItemList(1);
            },
            changepeoplepage2(num) {
                //换每页请求多少条
                this.pageSize2 = num;
                this.selectByPatientId(1);
            },
            changePeoplecurrent(num) {
                //换页
                this.current = num;
                this.selectOrgFeeItemList();
            },
            changePeoplecurrent2(num) {
                //换页
                this.current2 = num;
                this.selectByPatientId();
            },
            selectByPatientId(index) {
                //弹框
                this.isiconfontshow = true;
                if (index) {
                    this.current2 = 1;
                }
                let params = {
                    pageNum: this.current2,
                    pageSize: this.pageSize2,
                    idOrgReservation: this.idOrgReservation,
                    patientId: this.patientId,
                    orderField: this.orderField,
                    isAsc: this.isAsc
                };
                selectByPatientId(params).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.obj2 = res.data.data || {};
                        this.data2 = res.data.data.list || [];
                    }
                });
            },
            selectOrgFeeItemList(index, num) {
                //加项信息第二个表格接口
                this.isiconfontshow = true;
                if (index) {
                    this.current = 1;
                }
                if (num) {
                    this.medicalType = "";
                    this.endDate = "";
                    this.startDate = "";
                    this.orderField = "";
                    this.isAsc = "";
                }
                let params = {
                    pageNum: this.current,
                    pageSize: this.pageSize,
                    startDate: this.startDate,
                    endDate: this.endDate,
                    orderField: this.orderField,
                    isAsc: this.isAsc,
                    idOrgReservation: this.idOrgReservation
                };
                selectOrgFeeItemList(params).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.obj = res.data.data || {};
                        this.data = res.data.data.list || [];
                    }
                });
            },
            chengeTable(item) {
                //点击查看
                this.isAsc = "";
                this.orderField = "";
                this.patientId = item.idPatient;
                this.selectByPatientId(1);
                this.seeShow = true;
            },
            postItem(item) {
                //拿到父组件传来的参数
                this.idOrgReservation = item.idOrgReservation;
                this.selectOrgFeeItemList(1);
            }
        }
    };
</script>
<style lang="scss" scoped="" type="text/css">
    @import "../css/conmmon.scss";
    @import "../font/iconfont.css";
    .renwu {
        font-size: 13px;
        padding: 0px;
        width: 100%;
        height: 100%;
        overflow: hidden;
        overflow-y: scroll;
        overflow-y: visible;
        .top {
            width: calc(100% - 250px);
            height: 60px;
            line-height: 35px;
            position: fixed;
            top: 111px;
            z-index: 99;
            background: #fff;
            padding-top: 17px;
            left: 220px;
            padding-left: 15px;
            padding-bottom: 15px;
        }
        .select {
            width: 250px;
            margin-right: 15px;
        }
        .journal-input {
            width: 250px;
            vertical-align: top;
        }
        .data {
            width: 250px;
            vertical-align: top;
        }
        .table-cont {
            padding-top: 15px;
            margin: 40px 0 60px;
        }
        .page-div {
            width: 100%;
            margin-top: 15px;
            width: 100%;
            margin-top: 15px;
            position: fixed;
            background: #fff;
            width: calc(100% - 270px);
            height: 60px;
            z-index: 99;
            bottom: 0;
            padding-top: 15px;
            .page-div-left {
                float: left;
            }
            .page-div-page {
                float: right;
                margin-right: 15px;
            }
        }
    }
    
    .page-div {
        width: 100%;
        // margin-top: 15px;
        // position: fixed;
        // background: #fff;
        // width: calc(100% - 270px);
        // height: 60px;
        // z-index: 99;
        // bottom: 0;
        // padding-top: 15px;
        .page-div-left {
            float: left;
        }
        .page-div-page {
            float: right;
            margin-right: 15px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/xinxi/qiyeaddxiang2.vue